<template>
  <div v-bind:style="{
    'padding-bottom':
      (!$vuetify.breakpoint.mdAndUp && currentMode === 'detail') ? '56px' : 'initial',
  }">
    <div class="wrapper__btnSearch">
      <div class="container__btnSearch">
        <SearchGeneral
          ref="searchGeneral kai"
          :placeholder="$t('navbar.search')"
          :id="'search-general'"
          :querySearch='querySearch'
          @search="maybeGoToSearch($event)"
        ></SearchGeneral>
      </div>
    </div>

    <v-tabs
      v-if="!matchedId"
      v-model="tab"
      class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 maxw-1750"
    >
    <!-- CREAR SOLICITUD -->
      <v-tab>
        <div class="px-2 container__tabs">
          <div class="container_badge" v-if="isCatalog">
            <v-badge
              :value="!listViewData.loading"
              :content="listViewData.totalCatalogItems === 0
                ? '0'
                : listViewData.totalCatalogItems"
            >
            </v-badge>
          </div>
          <v-progress-circular
            v-if="!isCatalog"
            indeterminate
            size="20"
          ></v-progress-circular>
          <span class="tab__title__search">{{ $t('views.globalSearch.tabs.requestsItems' ) }}</span>
        </div>
      </v-tab>
<!-- MIS SOLICITUDES -->
      <v-tab>
        <div class="px-2 container__tabs">
          <div class="container_badge" v-if="isRequest">
            <v-badge
              :value="!listViewData.loading"
              :content="listViewData.totalRequests === 0
                ? '0'
                : listViewData.totalRequests"
            >
            </v-badge>
          </div>
          <v-progress-circular
            v-if="!isRequest"
            indeterminate
            size="20"
          ></v-progress-circular>
          <span class="tab__title__search">{{ $t('views.globalSearch.tabs.requests' ) }}</span>
        </div>
      </v-tab>
<!-- BUSCA TU SOLUCION -->
      <v-tab v-if="!isCitizen()">
        <div class="px-2 container__tabs">
          <div class="container_badge" v-if="isKnowledge">
            <v-badge
              :value="!listViewData.loading"
              :content="listViewData.totalKnowledgeItems===0
                ?'0'
                :listViewData.totalKnowledgeItems"
            >
            </v-badge>
          </div>
          <v-progress-circular
            v-if="!isKnowledge"
            indeterminate
            size="20"
          ></v-progress-circular>
          <span
            class="tab__title__search">{{ $t('views.globalSearch.tabs.knowledgeItems' ) }}</span>
        </div>
      </v-tab>
    </v-tabs>

    <list-navigator
      v-if="currentMode === 'detail' && !matchedId"
      class="mx-md-5 mx-lg-10 mx-xl-10 maxw-1750"
      backButtonHref="/knowledge-items"
      :disabled="navigatorParams.disabled"
      :total="navigatorParams.total"
      :current="navigatorParams.current"
      @navigate="(idx) => navigateToItem(idx)"
    />

    <list-adapter
      v-if="currentMode === 'list' "
      v-bind="tabComponentData"
      :querySearch='querySearch'
      :isCatalog='isCatalog'
      :isKnowledge='isKnowledge'
      :isRequest='isRequest'
    />

    <detail-adapter
      v-if="currentMode === 'detail'"
      v-bind="detailComponentData"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import { ListNavigator, SearchGeneral } from '@/components';

import TicketsListView from './TicketsListView.vue';
import TicketDetailView from './TicketDetailView.vue';
import KnowledgeItemsListView from './KnowledgeItemsListView.vue';
import KnowledgeItemsDetailView from './KnowledgeItemsDetailView.vue';
import RequestListView from './RequestListView.vue';

/*
 * we will create view adapters to normalize the list and detail views props
 */
const ListAdapter = Vue.extend({
  props: {
    component: Object,
    loading: Boolean,
    list: Array,
    querySearch: String,
    isCatalog: Boolean,
    isKnowledge: Boolean,
    isRequest: Boolean,
  },
  render(h) {
    const {
      component,
      loading,
      list,
      querySearch,
      isCatalog,
      isKnowledge,
      isRequest,
    } = this;
    return h(component, {
      props: {
        renderFilters: false,
        ticketType: 'R',
        listType: 'filtered',
        firstLoadDone: !loading,
        updatePathOnSearch: false,
        loading,
        list,
        items: list || [],
        total: (list || []).length,
        querySearch,
        isCatalog,
        isKnowledge,
        isRequest,
      },
    });
  },
});

const DetailAdapter = Vue.extend({
  props: {
    component: Object,
    loading: Boolean,
    id: [Number, String],
    data: Object,
  },
  render(h) {
    const {
      component, loading, data, id,
    } = this;
    return h(component, {
      props: {
        loading,
        loadingDetails: loading,
        loadingActivities: loading,
        id,
        idTicket: id ? id.toString() : null,
        ticketType: 'R',
        backButton: this.$vuetify.breakpoint.smAndDown,
        ...data,
      },
    });
  },
});

const LIST_PAGE_SIZE = 10;

export default {
  props: {
    query: {
      type: String,
      default: () => '',
    },
  },
  components: {
    ListAdapter,
    DetailAdapter,
    ListNavigator,
    SearchGeneral,
  },
  data() {
    return {
      lastSearchArgs: {},
      matchedId: false,
      loading: false,
      tab: null,
      listViewData: {
        requests: [],
        totalRequests: 0,
        knowledgeItems: [],
        totalKnowledgeItems: 0,
        catalogItems: [],
        totalCatalogItems: 0,
      },
      detailViewData: {
        id: null,
        data: {},
        backButton: false,
        loading: false,
        request: null,
      },
      currentMode: 'list',
      queriesArrivals: 0,
      tabSwitchAvailable: true,
      querySearch: '',
      isCatalog: false,
      isKnowledge: false,
      isRequest: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    const { name } = to;
    if (this.currentMode === 'list') {
      if (this.matchedId || !['TicketDetailView', 'KnowledgeItemsDetailView'].includes(name)) {
        next();
      } else {
        this.currentMode = 'detail';
        const { params: { id, idTicket } } = to;
        this.loadItemDetails(id || idTicket);
      }
    } else if (!['RequestListView', 'TicketsListView', 'KnowledgeItemsListView'].includes(name)) {
      next();
    } else {
      this.currentMode = 'list';
    }
  },
  watch: {
    query(value) {
      this.search(value, 0);
      this.querySearch = value;
    },
    tab() {
      // on tab change we will set view to list mode
      this.currentMode = 'list';
      if (this.detailViewData.request != null) {
        this.detailViewData.request.cancel();
        this.detailViewData.request = null;
        this.detailViewData.loading = false;
      }
    },
  },
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    tabComponentData() {
      let view = TicketsListView;
      let listItem = this.listViewData.requests;
      // AQUI ESTAN LOS COMPONENTES
      if (this.tab === 0) {
        view = RequestListView;
        console.log('GLOBALSEARCH', this.listViewData.catalogItems);
        listItem = this.listViewData.catalogItems;
      } else if (this.tab === 1) {
        view = TicketsListView;
        listItem = this.listViewData.requests;
      } else if (this.tab === 2) {
        view = KnowledgeItemsListView;
        listItem = this.listViewData.knowledgeItems;
      }

      return {
        component: view,
        loading: this.listViewData.loading,
        list: listItem,
      };
    },
    detailComponentData() {
      let componentDetailData;
      if (this.tab === 1) {
        componentDetailData = TicketDetailView;
      } else if (this.tab === 2) {
        componentDetailData = KnowledgeItemsDetailView;
      }

      return {
        component: componentDetailData,
        loading: this.detailViewData.loading,
        id: this.detailViewData.id,
        data: this.detailViewData.data,
      };
    },
    navigatorParams() {
      const { list } = this.tabComponentData;
      const detailData = this.detailComponentData.data;
      const item = detailData.item || detailData.details;
      return {
        disabled: this.detailViewData.loading,
        total: list.length,
        current: item == null ? -1 : list.findIndex((listItem) => listItem.id === item.id),
      };
    },
  },
  methods: {
    async search(query, page = 0) {
      this.tab = 0;
      this.isCatalog = false;
      this.isKnowledge = false;
      this.isRequest = false;

      const data = this.listViewData;

      data.loading = true;
      this.currentMode = 'list';

      try {
        const { lastSearchArgs } = this;

        const mustRequest = lastSearchArgs.query !== query;

        if (mustRequest) {
          if (page === 0) {
            data.requests = [];
            data.totalRequests = 0;
            data.knowledgeItems = [];
            data.totalKnowledgeItems = 0;
            data.catalogItems = [];
            data.totalCatalogItems = 0;
          }

          this.queriesArrivals = 0;
          this.searchTickets({ query, entity: 'tickets' });
          this.searchTickets({ query, entity: 'kis' });
          this.searchTickets({ query, entity: 'catalog' });

          /* this.matchedId = searchResult.matchedId; */
          data.lastSearchArgs = { query, page };
        }
      } catch (ex) {
        console.error('error getting global search page (query=', query, ')', ex);
      }

      data.loading = false;
    },
    async searchTickets({ query, entity }) {
      const data = this.listViewData;
      const response = await this.client.search({ query, entity }, LIST_PAGE_SIZE, null, 'open_date');
      const searchResult = response.unique();

      switch (entity) {
      case 'catalog':
        data.catalogItems = searchResult.catalogItems.list;
        data.totalCatalogItems = searchResult.catalogItems.total;
        this.isCatalog = true;
        this.listViewData.loading = false;
        // this.setTab(0, data.totalCatalogItems);
        break;
      case 'kis':
        data.knowledgeItems = searchResult.knowledgeItems.list;
        data.totalKnowledgeItems = searchResult.knowledgeItems.total;
        this.isKnowledge = true;
        this.listViewData.loading = false;
        // this.setTab(0, data.totalKnowledgeItems);
        break;
      case 'tickets':
        data.requests = searchResult.requests.list;
        data.totalRequests = searchResult.requests.total;
        this.isRequest = true;
        this.listViewData.loading = false;
        // this.setTab(0, data.totalRequests);
        break;
      default:
        break;
      }

      this.queriesArrivals += 1;

      if (this.queriesArrivals === 3) {
        this.tabSwitchAvailable = true;
        this.listViewData.loading = false;
      }
    },
    setTab(index, items) {
      if (items !== 0 && this.tabSwitchAvailable) {
        this.tab = 0;
      }

      // if (this.queriesArrivals === 2) {
      //   this.tabSwitchAvailable = true;
      // } else if (items !== 0) {
      //   this.tabSwitchAvailable = false;
      // }
    },
    navigateToItem(idx) {
      const item = this.tabComponentData.list[idx];
      this.loadItemDetails(item.id || item.idTicket);
    },
    async loadItemDetails(id) {
      console.log('open details for item ', id);
      const data = this.detailViewData;

      data.id = id;
      data.loading = true;

      if (data.request != null) {
        data.request.cancel();
        data.request = null;
      }

      let req;
      let cb;
      if (this.tab === 1) {
        // TODO
        const detailReq = this.$api.getClient('ticket').detail('R', id);
        const actReq = this.$api.getClient('activities').list(0, null, { idTicket: id }, 'time_stamp desc');
        req = Promise.all([detailReq, actReq]);
        req.cancel = () => {
          detailReq.cancel();
          actReq.cancel();
        };
        req.format = (response) => ({
          details: detailReq.format(response[0]).unique(),
          activities: actReq.format(response[1]).list,
        });
        cb = (response) => {
          data.data = req.format(response);
        };
      } else if (this.tab === 2) {
        const baseUrl = this.$router.options.base;
        req = this.$api.getClient('knowledgeItems').getDetail(id, baseUrl, this.publicView);
        cb = (response) => {
          const itemData = req.format(response).unique();
          data.data = { item: itemData };
          this.$root.$emit('setItemData', itemData);
        };
      }

      data.request = req;
      try {
        const response = await req;
        data.request = null;
        cb(response);
      } catch (ex) {
        console.error('ex', ex);
      }
      data.loading = false;
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
    maybeGoToSearch(e) {
      this.$root.$emit('search-global-home', e);
    },
  },
  created() {
    this.client = this.$api.getClient('globalSearch');
    const { query } = this;
    this.search(query);
    this.querySearch = query;
    console.log('querySearch === ', query);
  },
};
</script>

<style>
  .v-slide-group__prev.v-slide-group__prev--disabled {
    display: none !important;
    visibility: hidden;
  }
  .container__tabs {
    display: flex;
  }
  .container_badge {
    margin-right: 10px;
  }
  .v-tab {
    background-color: #f9f9f9;
    border-bottom: 2px solid #27846d;
    padding: 0 0.5rem;
  }
  .v-tab--active {
    border: 2px solid #27846d;
    background-color: #fff;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
  }
  .v-tabs-slider-wrapper {
    height: 0 !important;
  }
  .wrapper__btnSearch {
    margin: 2rem 0;
    padding: 0 8px;
  }
  .container_badge .v-badge__wrapper .v-badge__badge {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2rem;
  }
  .tab__title__search {
    margin-left: 16px;
  }
</style>
